import { render, staticRenderFns } from "./ChatProductCard.vue?vue&type=template&id=3a8d3b6a&scoped=true"
import script from "./ChatProductCard.vue?vue&type=script&lang=js"
export * from "./ChatProductCard.vue?vue&type=script&lang=js"
import style0 from "./ChatProductCard.vue?vue&type=style&index=0&id=3a8d3b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d3b6a",
  null
  
)

export default component.exports